import React from 'react';
import { MultiSelectComponents } from '@usealloy/component-library';
import type { OptionProps } from '@usealloy/component-library';
import type { WorkflowRoutingOption } from './types';
import { StyledDropdownSingleValueText } from './styles';

interface EditWorkflowRouterSingleValueProps extends OptionProps<WorkflowRoutingOption, false> { }
export default function EditWorkflowRouterSingleValue(props: EditWorkflowRouterSingleValueProps) {
  const {
    data: {
      label,
    },
  } = props;

  return (
    <MultiSelectComponents.SingleValue {...props}>
      <StyledDropdownSingleValueText>
        {label}
      </StyledDropdownSingleValueText>
    </MultiSelectComponents.SingleValue>
  );
}
